export default __webpack_public_path__ + "static/media/logo-tastic-new.7c626e37.png";